// EXTERNAL SOURCE
import MessageService from 'message-service/message-service';
import DataEvents from '../../../events/DataEvents';
import DistEvents from '../../../events/DistEvents';

import { tfsToDate, isTFS } from './TimecodeUtils';

const { UPDATE_EXTERNAL, NEW_TIMECODE } = DataEvents;
const { UPDATE_TFS } = DistEvents;

class ExternalSource {
    /**
     * Function start
     *
     * add listeners to external source topics, link 'em up to setTimecode
     */
    start () {
        MessageService.on(UPDATE_EXTERNAL, (data) => { // udpates coming from FV
            if (data.timecode) {
                this.setTimecode(data.timecode);
            }
        });
        MessageService.on(UPDATE_TFS, (timecode) => { // updates coming from Mini
            if (timecode) {
                this.setTimecode(timecode);
            }
        });
    }

    /**
     * Function setTimecode
     * @param timecode {String}
     *
     * @return {boolean} True signifies a valid timecode has been passed.  False, invalid.
     * converts timecode to JS date format, sets class variable, publishes on message service
     */
    setTimecode (timecode) {
        if (!timecode) {
            // if we got no value, you're stupid and i won't help you
            this.stop();
            return false;
        }
        if (isTFS(timecode)) {
            this.currentTimecode = tfsToDate(timecode);
        } else {
            const newTimecode = new Date(timecode);
            if (newTimecode) {
                this.currentTimecode = newTimecode;
            } else {
                this.timeMarchesOn = false;
            }
        }

        MessageService.publish(NEW_TIMECODE, {timecode: this.currentTimecode});

        return true;
    }

    /**
     * Function stop
     *
     *  remove listeners
     */
    stop () {
        MessageService.removeListener(UPDATE_EXTERNAL);
    }
}

export default ExternalSource;
